module.exports = __webpack_public_path__ + "static/media/raspash_vorota.c08ed0c6.jpg";